<template>
  <div>
    <h1>Access Denied!</h1>
  </div>
</template>

<script>
export default {
  name: "Error403"
}
</script>

<style scoped>

</style>
